// extracted by mini-css-extract-plugin
export default {"loanDueDate":"loanDueDate---AHnGE","tooltipIcon":"tooltipIcon---u2xXH"};